import axios from 'axios';
import { env } from '@shared/config/env';
import { normalizeBlobErrorResponse } from '@shared/utils/errors/normalizeBlobErrorResponse';

export const api = axios.create({
  baseURL: env.URL_SERVER_BACKEND,
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Token ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Axios devuelve los errores de descargas (responseType='blob') como Blob; se normalizan para que getErrorMessage pueda leer response.data.message
    await normalizeBlobErrorResponse(error);
    return Promise.reject(error);
  },
);